import { useEffect, useState } from "react";
import CustomSearchInput from "@/components/custom/custom-search-input";
import CustomSelectInput from "@/components/custom/custom-select-input";
import { DataTable } from "@/components/custom/data-table";
import { Stack, styled } from "@mui/material";
import { CustomerActivityColumns } from "../_components/customer-activity-column";
import CustomPagination from "@/components/custom/custom-pagination";
import { fetchCustomerActivitiesMock } from "../../data";

const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "16px 20px",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const ActivityLog = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetchCustomerActivitiesMock("CUST-00123", {
          page: 1,
          page_size: 25,
        });

        setData(res.activities);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Card>
      <Stack
        direction={"row"}
        spacing={3}
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction={"row"} spacing={3}>
          <CustomSearchInput
            paramKey="search"
            placeholder="Search activities..."
          />

          <CustomSelectInput
            paramKey="status"
            label="Status"
            placeholder="All Statuses"
            options={[
              { label: "Success", value: "success" },
              { label: "Failed", value: "failed" },
            ]}
          />
        </Stack>
      </Stack>

      <DataTable
        columns={CustomerActivityColumns}
        data={data}
        isLoading={loading}
        isError={false}
      />

      <CustomPagination
        total={84} // from mock
        perPageOptions={[5, 10, 20, 50, 100]}
      />
    </Card>
  );
};